<!--
 * @Author: DY
 * @Date: 2025-7-3 13:58:15
 * @LastEditTime: 2025-03-11 18:10:46
 * @Description: 原材料领用申请列表
 * @FilePath: \ShiMo_Mobile\src\views\storage\rawMaterialRequisitionApplication\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="rawMaterialRequisitionApplication commonListStyles">
            <HeaderNav header-title="原材料领用申请" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">出库单号：{{ item.outstock_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status | loadStatus }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>申请人：{{ item.apply_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>领用部门：{{ item.manage_org_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>制单时间：{{ item.time1 }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>领用部门负责人：{{ item.manage_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>库管员：{{ item.outstock_user_name }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.status === 0">
                                            <button @click="submit(item)">
                                                提交
                                            </button>
                                            <button @click="editApply(item, 'edit')">
                                                编辑
                                            </button>
                                            <button @click="deleteApply(item, 'edit')">
                                                删除
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button @click="editApply(item, 'see')">
                                                查看
                                            </button>
                                        </template>
                                        <button v-if="[3, 4].includes(item.status)" @click="generateQRCode(item)">
                                            查看二维码
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
                <button class="addBtn iconfont sm-icon-test" @click="addApply"></button>
                <van-popup v-model="showQrcode">
                    <canvas ref="qrcodeCanvas"></canvas>
                </van-popup>
            </section>
        </div>
    </v-touch>
</template>

<script>
import QRCode from 'qrcode';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'raw-material-requisition-application',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'raw-material-requisition-application');
        }
        next();
    },
    data() {
        return {
            tableCode: 'outstock_raw_material1',
            showQrcode: false,
        };
    },
    filters: {
        loadStatus(val) {
            const status = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废'];
            return status[val];
        },
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {},
    mounted() {},
    methods: {
        async submit(item) {
            this.$dialog.confirm({
                message: `确认提交出库单【${item.outstock_number}】吗？`,
            }).then(async () => {
                const res = await this.submitRequest(item.id);
                if (res) {
                    this.$toast.success('提交成功。');
                    this.onRefresh();
                }
            });
        },
        deleteApply(item) {
            this.$dialog.confirm({
                message: `确认删除出库单【${item.outstock_number}】吗？`,
            }).then(async () => {
                const res = await this.deleteRequest(item.id);
                if (res) {
                    this.$toast('删除成功！');
                    this.onRefresh();
                }
            });
        },
        addApply() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'rawMaterialRequisitionApplicationForm', params: { type: 'add' } });
        },

        editApply(item, type) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'rawMaterialRequisitionApplicationForm', params: { type, data: item } });
        },

        generateQRCode(item) {
            this.showQrcode = true;
            this.$nextTick(() => {
                const canvas = this.$refs.qrcodeCanvas;
                QRCode.toCanvas(canvas, item.outstock_number, error => {
                    if (error) {
                        this.$toast.fail(error);
                    }
                });
            });
        },

        submitRequest(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/submit/${id}`, {});
        },
        deleteRequest(id) {
            return this.$axios.$delete(`/interfaceApi/procurement/outstock/del/${id}`);
        },
    },
};
</script>
<style lang="stylus">
.rawMaterialRequisitionApplication
    section
        position: relative
        .van-pull-refresh
            height: calc(100% - 44rpx) !important
</style>
